import React, { FC } from 'react'
import { Stripe } from 'stripe'
import styles from 'styles/components/card.module.scss'
import text from 'styles/utility/text.module.scss'
import { FirebaseDocRefType } from 'firebase/index'
import { useQueryStoreName } from 'hooks/store'
import { useGetBillingDate } from 'hooks/invoice'

type Props = {
  invoice: Stripe.Invoice
  isSacriStation: boolean
  storeRef: FirebaseDocRefType
}

const InvoiceCardBody: FC<Props> = (props) => {
  const { invoice, isSacriStation, storeRef } = props
  const storeName = useQueryStoreName(storeRef)
  const billingDate = useGetBillingDate(invoice)
  return (
    <div className={styles.contract__detail}>
      <p>
        {billingDate}
        <br />
        {isSacriStation ? `(sacri station - ${storeName})` : `(${storeName})`}
      </p>
      <a
        className={`${text.color_blue_main} ${text.font_bold} ${text.link_none} ${text.nowrap}`}
        href={invoice.hosted_invoice_url || ''}
        target={'_blank'}
        rel={'noopener noreferrer'}
      >
        発行する
      </a>
    </div>
  )
}

export default InvoiceCardBody
